import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { CancelButton, SubmitButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import FormEmailRows from "components/forms/form-email-block";
import { faSave } from "components/icon-library";
import Modal from "components/layout/modal";
import { showError, showSuccess } from "lib/notification";
import { List } from "models/list";
import { ListEmailTemplate } from "models/list-email-template";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { adminDoPostListEmailTemplate } from "services/admin/list-email-template";
import * as yup from "yup";

interface EmailTemplateModalProps {
  list: List;
  template: ListEmailTemplate;
  onUpdate: () => Promise<void>;
  onClose: () => Promise<void>;
}

const EmailTemplateModal: FunctionComponent<EmailTemplateModalProps> = ({
  list,
  template,
  onUpdate,
  onClose,
}) => {
  const schema = yup
    .object({
      subject: yup.object().validateLocaleString(),
      message: yup.object().validateLocaleString(),
    })
    .required();

  const methods = useForm({
    mode: "onSubmit",
    reValidateMode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: {
      subject: template.subject,
      message: template.message,
    },
  });

  const buttons: FormButtonInterface[] = [
    { ...CancelButton, onClick: onClose },
    { ...SubmitButton, text: "Tallenna", postIcon: faSave },
  ];

  const handleSubmit = async (values: any) => {
    const { subject, message } = values;

    try {
      await adminDoPostListEmailTemplate(list, template.type, {
        subject,
        message,
      });
      showSuccess("Sähköpostimallin tallentaminen onnistui.");
    } catch (err) {
      showError("Sähköpostimallin tallentaminen epäonnistui.");
    }

    // update data beneath
    onUpdate();

    // close
    onClose();
  };

  return (
    <Modal title="Muokkaa sähköpostipohjaa" wide>
      <Form onSubmit={handleSubmit} methods={methods}>
        <FormEmailRows />
        <FormButtons buttons={buttons} />
      </Form>
    </Modal>
  );
};

export default EmailTemplateModal;
